$(document).ready(function () {
    // Cache the target element
    var target = $('.two-column-block.__reviews');

    // Function to check if the target is in view
    function checkInView() {
        var windowTop = $(window).scrollTop();
        var windowBottom = windowTop + $(window).height();
        var offset = 600; // Offset from the top of the viewport
        var break_point = 992;
        var browser_width = window.innerWidth;

        target.each(function () {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).height();

            // Check if the element is 600px from the top of the viewport
            if (elementTop < (windowBottom - offset) && elementBottom > (windowTop + offset) && (browser_width >= break_point)) {
                $(this).addClass('__in-view');
            } else {
                $(this).removeClass('__in-view');
            }
        });
    }

    // Run the check on scroll
    $(window).on('scroll', checkInView);

    // Run the check on document ready in case the element is already in view
    checkInView();
});